import { render } from "./TelInput.vue?vue&type=template&id=736fa118&scoped=true"
import script from "./TelInput.vue?vue&type=script&lang=js"
export * from "./TelInput.vue?vue&type=script&lang=js"

import "./TelInput.vue?vue&type=style&index=0&id=736fa118&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736fa118"]])

export default __exports__